<template>
  <v-col class="pa-6">
    <div v-if="!viewingRequest">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            class="input ma-0 pa-0"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            rounded
            :hide-details="true"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="Status Type"
              v-model="selectedType"
              :items="statusTypes"
              rounded
              :hide-details="true"
              clearable
            ></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          style="width: 100%"
          :headers="headers"
          :items="filteredRequests"
          :items-per-page="10"
          class="elevation-1 mt-4 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon color="#4390c0" @click="viewRequest(item)"
                >mdi-eye</v-icon
              >
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
            >
              {{ item.status || "pending" }}
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingRequest">
      <v-row justify="center">
        <v-row class="ma-2">
          <v-col cols="12" md="6">
            <v-row class="mb-2">
              <v-icon class="black-color" @click="close()">
                mdi-arrow-left
              </v-icon>
              <h4 class="grey-color mx-4" style="font-weight: 500">
                Request Info
              </h4>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
      <v-row justify="center" justify-md="start">
        <div class="white-card pa-8">
          <v-row justify="start" class="ma-0">
            <h2 class="fs400 mb-4">Request Info</h2>
            <v-chip
              class="status-chip mx-2 mt-1"
              style="text-transform: capitalize"
              :color="statusColor(selectedRequest.status || 'Pending')"
              dark
            >
              {{ selectedRequest.status || "Pending" }}
            </v-chip>
          </v-row>
          <v-row justify="center" justify-md="start" class="ma-0">
            <v-col cols="12" md="6">
              <v-row justify="start" class="mt-4">
                <v-col cols="12" md="6">
                  <v-row>
                    <p><strong>Title:</strong></p>
                  </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.title"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start" class="mt-4">
                <v-col cols="12" md="6">
                  <v-row>
                    <p><strong>Date Created:</strong></p>
                  </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.date"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start" class="mt-4">
                <v-col cols="12" md="6">
                  <v-row>
                    <p><strong>Doctor:</strong></p>
                  </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.doctorFullName"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="start" class="mt-4">
                <v-col cols="12" md="6">
                  <v-row>
                    <p><strong>Description:</strong></p>
                  </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      filled
                      outlined
                      dense
                      rounded
                      v-model="selectedRequest.description"
                    >
                    </v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <p><strong>Image:</strong></p>
              </v-row>
              <v-row justify="center" justify-md="start">
                <img :src="selectedRequest.image" class="image mb-6" />
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <v-row class="mt-4" justify="center" justify-md="start">
                <p><strong>Product Status:</strong></p>
              </v-row>
              <v-row justify="center" justify-md="start">
                <v-select
                  style="max-width: 240px"
                  class="ma-0 pa-0"
                  v-model="selectedRequest.status"
                  :items="statusTypes"
                  dense
                  filled
                  outlined
                  rounded
                  :hide-details="true"
                ></v-select>
              </v-row>
              <v-row
                justify="center"
                justify-md="start"
                v-if="selectedRequest.status === 'denied'"
                class="mt-8"
              >
                <v-textarea
                  style="max-width: 240px"
                  v-model="selectedRequest.reason"
                  label="Reason for Denial"
                  auto-grow
                  outlined
                  filled
                  clearable
                  rounded
                  rows="2"
                  :rules="[(v) => !!v || 'Reason is required']"
                ></v-textarea>
              </v-row>
              <v-row justify="center" justify-md="start">
                <v-btn
                  @click="updateStatus()"
                  color="#e022d1"
                  dark
                  rounded
                  width="240px"
                  class="pink-btn mt-4"
                >
                  Update Status
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-row>
    </div>
    <!-- Loading Overlay -->
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  getFirestore,
  setDoc,
  query,
  doc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

import { logAction, sendPushNotificationUser } from "@/utils/firestoreUtil";

export default {
  data() {
    return {
      headers: [
        { text: "Product Name", value: "title" },
        { text: "Description", value: "description" },
        { text: "Date Created", value: "date" },
        { text: "Doctor", value: "doctorFullName" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      search: "",
      statusTypes: ["pending", "approved", "denied"],
      selectedType: "pending",
      requests: [], // your products array
      selectedRequest: null,
      viewingRequest: false,
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      doctors: [],
      unsubscribeProducts: null,
      unsubscribeDoctors: null,
    };
  },
  methods: {
    close() {
      this.viewingRequest = false;
      localStorage.removeItem("ViewedRequest");
    },
    viewRequest(item) {
      this.selectedRequest = item;
      this.viewingRequest = true;
      localStorage.setItem(
        "ViewedRequest",
        JSON.stringify(this.selectedRequest)
      );
    },
    getProducts() {
      try {
        this.loading = true;
        const q = query(collection(db, "products"));

        // Subscribe to real-time updates
        this.unsubscribeProducts = onSnapshot(q, (querySnapshot) => {
          this.requests = [];

          querySnapshot.forEach((doc) => {
            let product = doc.data();
            product.id = doc.id;

            // Handle Firestore Timestamp or already-formatted string
            if (product.createdAt) {
              if (
                typeof product.createdAt === "object" &&
                product.createdAt.seconds
              ) {
                product.date = new Date(
                  product.createdAt.seconds * 1000
                ).toLocaleString();
              } else {
                product.date = product.createdAt;
              }
            } else {
              product.date = "";
            }

            // Find the doctor
            product.doctor = this.doctors.find((d) => product.userId === d.id);
            if (product.doctor) {
              product.doctorFullName = `${product.doctor.name} ${product.doctor.surname}`;
            }

            // Default status
            if (!product.status) {
              product.status = "pending";
            }

            this.requests.push(product);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
        this.promptMessage = "An error occurred while fetching products!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#e022d1";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        default:
          return "grey";
      }
    },
    async updateStatus() {
      try {
        if (
          this.selectedRequest.status === "denied" &&
          !this.selectedRequest.reason
        ) {
          this.promptMessage = "Please provide a reason for denial.";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        this.loading = true;

        await setDoc(doc(db, "products", this.selectedRequest.id), {
          ...this.selectedRequest,
          reason:
            this.selectedRequest.status === "denied"
              ? this.selectedRequest.reason
              : "",
        });

        this.loading = false;

        if (this.selectedRequest.status == "denied") {
          if (this.selectedRequest.doctor.fcmToken) {
            let res = await sendPushNotificationUser(
              "Product Denied",
              "Your product: " +
                this.selectedRequest.title +
                " has been declined for the following reason: " +
                this.selectedRequest.reason,
              this.selectedRequest.doctor.fcmToken
            );
          }
          this.addNotification(
            this.selectedRequest.userId,
            "Product Denied",
            "Your product: " +
              this.selectedRequest.title +
              " has been declined for the following reason: " +
              this.selectedRequest.reason
          );
        } else if (this.selectedRequest.status == "approved") {
          if (this.selectedRequest.doctor.fcmToken) {
            let res = await sendPushNotificationUser(
              "Product Approved",
              "Your product: " +
                this.selectedRequest.title +
                " has been approved",
              this.selectedRequest.doctor.fcmToken
            );
          }
          this.addNotification(
            this.selectedRequest.userId,
            "Product Approved",
            "Your product: " + this.selectedRequest.title + " has been approved"
          );
        }

        await this.logStatusUpdate();

        this.promptMessage = "Successfully updated product's status!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
        this.promptMessage =
          "An error occurred while updating the product's status, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async logStatusUpdate() {
      await logAction(
        "Product Management",
        "Status Update",
        this.loggedInUser.email,
        `${this.loggedInUser.email} updated product ${
          this.selectedRequest.id
        } status to ${this.selectedRequest.status}. Reason: ${
          this.selectedRequest.reason || "N/A"
        }`
      );
    },
    getDoctors() {
      try {
        this.loading = true;
        const q = query(collection(db, "doctors"));

        // Subscribe to real-time updates
        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doctor) => {
            let tempDoctor = doctor.data();
            tempDoctor.id = doctor.id;

            this.doctors.push(tempDoctor);
          });

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the doctors!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async addNotification(userID, type, message) {
      let notification = {
        createdAt: new Date(),
        userType: "Doctor",
        userID: userID,
        type: type,
        message: message,
      };

      try {
        this.loading = true;
        let res2 = await addDoc(collection(db, "alerts"), notification);
        this.loading = false;
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
      }
    },
  },
  async created() {
    let res = await this.getDoctors();
    await this.getProducts();

    if (localStorage.getItem("ViewedRequest")) {
      let selectedRequest = JSON.parse(localStorage.getItem("ViewedRequest"));
      let newRequest = this.requests.find(
        (request) => request.id == selectedRequest.id
      );

      if (newRequest) {
        this.selectedRequest = newRequest;
        this.viewingRequest = true;
      }
    }
  },
  computed: {
    filteredRequests() {
      return this.requests.filter((item) => {
        const matchesStatus =
          !this.selectedType ||
          (item.status &&
            item.status.toLowerCase() === this.selectedType.toLowerCase());

        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        return matchesStatus && matchesSearch;
      });
    },

    loggedInUser() {
      return this.$store.state.user || {};
    },
  },
  beforeUnmount() {
    if (this.unsubscribeProducts) {
      this.unsubscribeProducts();
    }

    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }
  },
};
</script>

<style scoped>
.reason-field {
  background-color: #fafafa;
  border-radius: 12px;
}

.image {
  width: 200px;
  border: 2px solid grey;
}
</style>
